<template>
	<div class="iv2-coupon">
		<p class="text-center mt-5">
			<button @click="openModal" class="iv2-coupon__btn theme__sub-btn">クーポンを使う</button>
		</p>
		<p
			v-if="coupon.limit_start"
			class="iv2-coupon__text text-center"
		>有効期限：{{ coupon.limit_start | moment }}〜{{ coupon.limit_end | moment }}</p>
		<LayoutSlot @close="closeModal" v-if="modal">
			<!-- default スロットコンテンツ -->
			<div v-if="couponActive == false">
				<p class="iv2-coupon__modal-text">
					表示されるクーポン画面を
					<br />会計時にレジのスタッフへご提示ください。
					<br />今すぐ使用しますか？
				</p>
				<small class="iv2-coupon__modal-text-small">
					「はい」をクリックすると使用できます。
					<br />お手持ちのスマートフォンかタブレットでご利用ください。
					<br />クーポンは何度でもご利用いただけます。
				</small>
			</div>
			<!-- /default -->

			<!-- footer スロットコンテンツ -->
			<template slot="footer" v-if="couponActive == false">
				<button @click="closeModal" class="iv2-coupon__sub-btn">いいえ</button>
				<button @click="doAction" class="iv2-coupon__sub-btn">はい</button>
			</template>
			<!-- /footer -->

			<div v-if="couponActive == true" class="text-center">
				<button @click="closeModal" class="iv2-coupon__close-btn"></button>
				<div class="iv2-coupon__img">
					<img :src="coupon.image" />
				</div>
				<p class="iv2-coupon__modal-text">有効期限{{ formatTime }}</p>
				<p class="iv2-coupon__label">使用済み</p>
			</div>
		</LayoutSlot>
	</div>
</template>

<script>
import LayoutSlot from "./LayoutSlot.vue";
import moment from "moment";

export default {
	components: {
		LayoutSlot
	},
	props: ["coupon"],
	data() {
		return {
			modal: false,
			couponActive: false,
			countDown: "",
			min: 30,
			sec: 0
			// limitStart: "2020-06-14 00:00:00",
			// limitEnd: "2021-06-14 18:00:00"
		};
	},
	methods: {
		openModal() {
			this.modal = true;
		},
		closeModal() {
			this.modal = false;
		},
		doAction() {
			this.couponActive = true;
		}
	},

	computed: {
		formatTime: function() {
			let timeStrings = [this.coupon.limit_end].map(function(str) {
				if (str.length < 2) {
					return "0" + str;
				} else {
					return str;
				}
			});
			var param = new Date(timeStrings[0]);
			return (timeStrings[0] =
				param.getFullYear() +
				"年" +
				(param.getMonth() + 1) +
				"月" +
				param.getDate() +
				"日" +
				param.getHours() +
				"時" +
				param.getMinutes() +
				"分");
		}
	},
	// console.log(
	// 	param.getFullYear() +
	// 		"年" +
	// 		param.getMonth() +
	// 		"月" +
	// 		param.getDate() +
	// 		"日" +
	// 		param.getHours() +
	// 		"時" +
	// 		param.getMinutes() +
	// 		"分"
	// );

	filters: {
		moment: function(limit_start, limit_end) {
			return moment(limit_start, limit_end).format("YYYY年MM月DD日");
		}
	}
};
</script>

<style lang="scss">
.iv2-coupon {
	.iv2-coupon__btn {
		cursor: pointer;
		text-align: center;
		display: inline-block;
		border: 0;
		letter-spacing: 2px;
		width: 300px;
		padding-top: 15px;
		padding-bottom: 15px;
		border-radius: 0;
	}

	.iv2-coupon__sub-btn {
		cursor: pointer;
		text-align: center;
		display: inline-block;
		margin-top: 30px;
		margin-left: 20px !important;
		margin-right: 20px !important;
		color: #fff;
		background-color: transparent;
		border: 2px solid #fff;
		border-radius: 30px;
		width: 200px;
		font-size: 1.5rem;
	}

	.iv2-coupon__img {
		background-color: #fff;
		padding: 25px;
		margin-bottom: 50px;

		> img {
			max-width: 550px;
		}
	}

	.iv2-coupon__close-btn {
		position: absolute;
		right: 0px;
		top: 0px;
		height: 40px;
		width: 40px;
		background-color: #000;
		border: none;
		cursor: pointer;
		outline: none;
		padding: 0;
		border-radius: 30px;

		&:before,
		&:after {
			content: "";
			background-color: #fff;
			height: 3px;
			width: 20px;
			display: block;
			position: absolute;
			right: 10px;
			top: 19px;
		}

		&:before {
			transform: rotate(-45deg);
		}

		&:after {
			transform: rotate(45deg);
		}
	}

	.iv2-coupon__label {
		text-align: center;
		display: inline-block;
		color: #fff;
		background-color: transparent;
		border: 2px solid #fff;
		border-radius: 30px;
		width: 200px;
		font-size: 1.5rem;
		margin: 0;
	}

	.iv2-coupon__text {
		font-size: 18px;
	}

	.iv2-coupon__modal-text {
		text-align: center;
		font-size: 2rem;
		color: #fff;
	}

	.iv2-coupon__modal-text-small {
		display: block;
		text-align: center;
		font-size: 1rem;
		color: #fff;
	}
}

@media (max-width: 767px) {
	.iv2-coupon {
		.iv2-coupon__text {
			font-size: 14px;
		}

		.iv2-coupon__modal-text {
			font-size: 1.2rem;
		}

		.iv2-coupon__sub-btn {
			font-size: 1.2rem;
		}

		.iv2-coupon__img {
			padding: 15px;
			> img {
				max-width: 300px;
			}
		}
	}
}
</style>